<footer class="wb-footer" layout="column" layout-align="end center" ng-hide="app.hasNavigation" ng-cloak>
  <nav>
    <md-button ng-href="{{::'auth.imprint.url' | translate}}" target="_blank">{{::'auth.imprint.title' | translate}}</md-button>
  </nav>

  <small class="wb-copyright-notice">
    &copy; Copyright 2026 Rewin Kft. {{::'auth.copyrightNotice' | translate}}
  </small>
</footer>
